import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faCakeCandles,
  faUsers,
  faRing,
  faPeopleGroup
} from '@fortawesome/free-solid-svg-icons';
import backgroundImage from '../Images/fundoUniversoTempo.png';
import backgroundImageMobile from '../Images/cardMobileTempo.png';
import cardImage from '../Images/cardUniversoTempo.png';
import '../CSS/DesafiosChallenges.css';
import '../CSS/HomeInicio.css';

const experiences = [
  {
    icon: faCakeCandles,
    title: 'Aniversários',
    description: 'Celebra de forma diferente e inesquecível!',
    to: '/aniversarios'
  },
  {
    icon: faUsers,
    title: 'Team Building',
    description: 'Fortalece a tua equipa com diversão e estratégia.',
    to: '/team-buildings'
  },
  {
    icon: faRing,
    title: 'Despedidas de Solteir@',
    description: 'Uma despedida épica que ninguém vai esquecer!',
    to: '/despedidas-solteiro'
  },
  {
    icon: faPeopleGroup,
    title: 'Grupos & Famílias',
    description: 'Aventura para todas as idades.',
    to: '/loreto-challenge'
  }
];

const Inicio = () => {
  const handleClick = (desafioId) => {
    localStorage.setItem('selectedChallenge', desafioId);
  };

  return (
    <div className="er-homePage">
      <section className="er-hero" aria-label="Escape Room Bragança">
        <picture className="er-heroMedia">
          <source media="(max-width: 600px)" srcSet={backgroundImageMobile} />
          <img src={backgroundImage} alt="" className="er-heroImg" />
        </picture>

        <div className="er-heroOverlay">
          <div className="er-container er-heroInner">
            <p className="er-homeHeroKicker">Preparados para o desafio?</p>
            <h1 className="er-heroTitle">Escape Room Bragança</h1>

            <div className="er-heroFeature">
              <img src={cardImage} className="er-heroFeatureImg" alt="" />
              <div className="er-heroFeatureText">
                <div className="er-heroKicker">Em destaque</div>
                <div className="er-heroFeatureTitle">O Viajante do Tempo</div>
                <div className="er-heroFeatureSub">Que mistérios esconde?</div>
              </div>
            </div>

            <div className="er-heroCtas">
              <Link
                className="er-button er-button-primary"
                to="/reservas"
                onClick={() => handleClick('3')}
              >
                Reservar agora
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="er-homeExperiences" aria-label="Experiências">
        <div className="er-container">
          <div className="er-homeExperiencesHead">
            <h2 className="er-homeExperiencesTitle">Escolhe a tua experiência</h2>
            <p className="er-homeExperiencesSubtitle">
              Temos a experiência perfeita para cada ocasião.
            </p>
          </div>

          <div className="er-homeExperiencesGrid">
            {experiences.map((item) => (
              <Link key={item.title} to={item.to} className="er-homeExperienceCard">
                <div className="er-homeExperienceIconTitleDiv">
                  <FontAwesomeIcon icon={item.icon} className="er-homeExperienceIcon" />
                  <h3 className="er-homeExperienceTitle">{item.title}</h3>
                </div>
                <p className="er-homeExperienceDesc">{item.description}</p>
                <span className="er-homeExperienceLink">
                  Saber mais <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Inicio;
